import { useContext, useMemo } from 'react';

import { AtomMap, MarkerLayer, useDefaultMapLocation } from '@atom/map';
import { BoundingBoxSubjectType, MapData, MapLocation } from '@atom/types/map';
import { TaskLocation } from '@atom/types/taskLocation';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import LocationsAndAssetsContext from '../LocationsAndAssetsContext';

type TaskLocationMapProps = {
  editMode?: boolean;
  location?: TaskLocation;
  locations?: TaskLocation[];
  hoverId?: string;
};

const TaskLocationMap = ({
  editMode = false,
  location,
  locations = [],
  hoverId = '',
}: TaskLocationMapProps) => {
  const { workOrderDetail, task } = useContext(LocationsAndAssetsContext);
  const defaultLocation = useDefaultMapLocation();

  const data: MapData = useMemo(() => {
    const activeLocation: MapLocation[] = !isNilOrEmpty(location?.geometry)
      ? [
          {
            id: location.id,
            name: location.name,
            geometry: location.geometry,
            statusId: workOrderDetail?.statusId,
            isActive: true,
          },
        ]
      : [];

    return {
      locations: [
        ...activeLocation,
        ...locations.map(
          (item): MapLocation => ({
            id: item.id,
            name: item.name,
            geometry: item.geometry,
            statusId: workOrderDetail?.statusId,
            isActive: hoverId === item?.id,
          }),
        ),
      ],
    };
  }, [location, locations, workOrderDetail, hoverId]);

  return (
    <AtomMap
      initialViewState={defaultLocation}
      compactToolbars
      frameTask={{
        subjectType: BoundingBoxSubjectType.LOCATION,
        taskId: task?.id,
        workOrderId: workOrderDetail?.id,
        active: !editMode && !isNilOrEmpty(locations),
        frameKey: locations.map(item => item.id).join(','),
        locationGeometry: location?.geometry ?? null,
      }}
    >
      <MarkerLayer data={data} />
    </AtomMap>
  );
};

export default TaskLocationMap;
